import Vue from 'vue';
import VueRouter from 'vue-router';
import Admin from '@/pages/Admin';
import AdminUser from '@/pages/Admin/User';
import AdminRole from '@/pages/Admin/User/Role';
import AdminMenu from '@/pages/Admin/User/Menu';
import AdminUserInfo from '@/pages/Admin/User/Info';
import AdminGoods from '@/pages/Admin/Goods';
import AdminGoodsType from '@/pages/Admin/Goods/Type';
import AdminGoodsBrand from '@/pages/Admin/Goods/Brand';
import AdminGoodsAdd from '@/pages/Admin/Goods/add.vue';
import AdminLog from '@/pages/Admin/Log';
import Shop from '@/pages/Admin/Shop';
import BaoJia from '@/pages/Admin/BaoJia';
import ComInfo from '@/pages/Admin/ComInfo';
import CusInfo from '@/pages/Admin/CusInfo';
import Ceshi from '@/pages/Admin/Ceshi';
import GoodsOrder from '@/pages/Admin/Goods/Order';
Vue.use(VueRouter);
export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            name: '后台首页',
            path: '/admin',
            component: Admin,
            redirect: '/admin/user',
            meta: {
                metaInfo: {
                    title: '邦邦报价-后台首页',
                    keywords: '',
                    description: ''
                }
            },
            children: [
                {
                    name: '员工管理',
                    path: 'user',
                    component: AdminUser,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-员工管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '个人信息',
                    path: 'info',
                    component: AdminUserInfo,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-个人信息',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '角色管理',
                    path: 'role',
                    component: AdminRole,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-角色管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '菜单管理',
                    path: 'menu',
                    component: AdminMenu,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-菜单管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '商品管理',
                    path: 'goods',
                    component: AdminGoods,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-商品管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '分类管理',
                    path: 'goodstype',
                    component: AdminGoodsType,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-分类管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '品牌管理',
                    path: 'goodsbrand',
                    component: AdminGoodsBrand,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-品牌管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '添加商品',
                    path: 'goodsadd',
                    component: AdminGoodsAdd,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-添加商品',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '操作日志',
                    path: 'log',
                    component: AdminLog,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-操作日志',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '采购中心',
                    path: 'shop',
                    component: Shop,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-采购中心',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '报价单生成',
                    path: 'baojia',
                    component: BaoJia,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-报价单生成',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '报价信息生成',
                    path: 'cominfo',
                    component: ComInfo,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-报价信息生成',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '询价信息生成',
                    path: 'cusinfo',
                    component: CusInfo,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-询价信息生成',
                            keywords: '',
                            description: ''
                        }
                    }
                },
                {
                    name: '订单管理',
                    path: 'order',
                    component: GoodsOrder,
                    meta: {
                        metaInfo: {
                            title: '邦邦报价-订单管理',
                            keywords: '',
                            description: ''
                        }
                    }
                },
            ]
        },
        {
            name: 'ceshi',
            path: '/ceshi',
            component: Ceshi,
            meta: {
                metaInfo: {
                    title: '邦邦报价-ceshi',
                    keywords: '',
                    description: ''
                }
            }
        },
        {
            path: '*',
            redirect: '/admin'
        }
    ]
});